import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';
import { RADIUS } from '~/common/constants/border-radius';
import { Z_INDEX } from '~/common/constants/z-index';

export const StyHeader = styled.div`
  position: relative;
  display: flex;
  min-height: 65px;
  max-height: 65px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.primary_header} 0%,
    ${({ theme }) => theme.primary} 100%
  );
  width: 100%;
  box-shadow: 0 8px 32px ${({ theme }) => `${theme.primary}40`},
    inset 0 1px 0 rgba(255, 255, 255, 0.22);
  z-index: ${Z_INDEX.HEADER};
  align-items: center;
  padding: ${SPACING._4} ${SPACING._20};
  justify-content: flex-end;
  gap: ${SPACING._32};

  .MuiIconButton-root {
    color: #ffffff;

    &:hover {
      background-color: rgba(255, 255, 255, 0.14);
    }
  }

  .MuiBadge-badge {
    background-color: #ffffff;
    color: ${({ theme }) => theme.primary_header};
    font-weight: 700;
  }

  & > button:first-of-type {
    display: none;
  }

  @media (max-width: 1279px) {
    justify-content: space-between;

    & > button:first-of-type {
      display: unset;
    }
  }
`;

export const StyActions = styled.div`
  display: flex;
  max-width: 330px;
  width: fit-content;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING._32};
`;

export const StyLogoWrapper = styled.div`
  display: none;
  margin-right: auto;
  align-items: center;

  @media (max-width: 1279px) {
    display: flex;
  }
`;
